export enum PowerBIDashboard {
  GET_POWERBI_REPORTS = "GET_POWERBI_REPORTS",
  GET_POWERBI_REPORTS_SUCCESS = "GET_POWERBI_REPORTS_SUCCESS",
  GET_POWERBI_REPORTS_FAIL = "GET_POWERBI_REPORTS_FAIL",
}
